import { base64ToHtmlURL } from 'utils';

export const getLinkFromCasinoGameData = data => {
  let link = 'about:blank';

  if (data && data.type === 'BASE64') {
    link = base64ToHtmlURL(data.link);
  } else if (data) {
    link = new URL(data.link, document.baseURI).toString();
  }

  return link;
};

export const getGameIdentifier = game => {
  if (!game) return undefined;
  return game.gameRelationId ?? game.id;
};
